import { Card, CardHeader, Typography, Divider } from "@mui/material";
import CustomCardContent from "./CustomCardContent";
import { WalkthroughAttachmentOut } from "@providers/hop-ord-server/api";
import ImageCarousel from "@pages/PhysicianReview/components/ImageCarousel";

interface Props {
  walkthroughAttachmentsLoading: boolean;
  imagesAvailable: boolean;
  images: WalkthroughAttachmentOut[];
}
const ImageCard = ({
  walkthroughAttachmentsLoading,
  imagesAvailable,
  images,
}: Props) => {
  return (
    <Card variant="outlined" data-testid="images-card">
      <CardHeader title={<Typography variant="h6">Images</Typography>} />
      <Divider />
      <CustomCardContent
        isLoading={walkthroughAttachmentsLoading}
        isEmpty={!imagesAvailable}
        contentDisplayType="image"
      >
        {imagesAvailable && <ImageCarousel images={images} />}
      </CustomCardContent>
    </Card>
  );
};
export default ImageCard;
